<cgw-carousel-base
  [config]="carouselConfig()"
  [items]="carouselItems()">
</cgw-carousel-base>

<ng-template
  #bannerTemplate
  let-image="image">
  <div class="picture-container">
    <a
      id="main_banner"
      target="{{ image.ventana == 1 ? '_blank' : '_self' }}"
      href="{{ image.link }}">
      <picture>
        <source
          media="(min-width: 1200px)"
          srcset="{{image.nombre_xxl}}" />
        <source
          media="(min-width: 992px)"
          srcset="{{image.nombre_xl}}" />
        <source
          media="(min-width: 768px)"
          srcset="{{image.nombre_lg}}" />
        <source
          media="(min-width: 576px)"
          srcset="{{image.nombre_md}}" />
        <img
          src="{{ image.nombre_sm }}"
          alt="{{ image.descripcion }}"
          class="original-img" />
      </picture>
    </a>
  </div>
</ng-template>
